import store from "@/store";
import InArray from "@/service/helpers/InArray";

export default function (route){
    if (!store.state.authenticate.auth.user.email_verified_at){
        return false
    }

    if (!store.state.ageVerification.verificationLink){
        return false
    }

    return !InArray(route.name, ['login', 'register', 'ageVerification']);
}